const AuthFlowType = {
	OAUTH: "OAUTH",
	USER_PASSWORD_AUTH: "USER_PASSWORD_AUTH",
	USER_SRP_AUTH: "USER_SRP_AUTH"
};
export default AuthFlowType;
